import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

/**
 * Prominent live Central Time clock for the admin header.
 *
 * Ticks every second so any admin can verify at a glance that the
 * platform is operating on America/Chicago — the only timezone used
 * for day boundaries on every financial report and snapshot.
 */
const LiveCtClock = ({ testId = 'live-ct-clock' }) => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    const timeFmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
    });
    const dateFmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        weekday: 'short',
        month: 'short',
        day: 'numeric',
    });

    return (
        <div
            className="hidden md:inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-[#FFD700]/10 border border-[#FFD700]/30"
            title="All reports, snapshots, and day boundaries use America/Chicago"
            data-testid={testId}
        >
            <Clock className="w-4 h-4 text-[#FFD700]" />
            <div className="flex flex-col leading-tight">
                <span className="text-[10px] uppercase tracking-wider text-[#FFD700]/80 font-bold">
                    Central Time
                </span>
                <span className="text-sm font-mono font-bold text-white tabular-nums">
                    {dateFmt.format(now)} · {timeFmt.format(now)}
                </span>
            </div>
        </div>
    );
};

export default LiveCtClock;
